import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";

import { tenantSelectors } from "store/selectors";
import { getFundManagerInstanceURL } from "utils";

import AwardAccountView from "containers/Awards/Detail/Account";
import FormFundsView from "components/FormFundsView/FormFundsView";

const FundSummaryView = () => {
    const tenantId = useSelector(tenantSelectors.tenantId);
    const [fundURL, setFundURL] = useState();
    const [isLoaded, setLoaded] = useState(false);

    useEffect(() => {
        if (tenantId) {
            getFundManagerInstanceURL(tenantId)
                .then((url) => setFundURL(url))
                .finally(() => setLoaded(true));
        }
    }, [tenantId]);

    return isLoaded ? (
        <>
            {fundURL && <FormFundsView url={fundURL} />}
            {!fundURL && <AwardAccountView></AwardAccountView>}
        </>
    ) : (
        <LoadingIndicator />
    );
};

export default FundSummaryView;
